import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBrackets1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"brackets-1"} maskId="square-filled-radius-0-stroke-1-IconBrackets1"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H8V4H4V20H8V21H3V3ZM16 3H21V21H16V20H20V4H16V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBrackets1;
